import React from 'react';
import { UserProfileModal as UserProfileModalComponent } from '@appsource/components/modals/userProfileModal';
import { getUserProfile, updateUserProfile } from '@shared/actions/thunkActions';
import { connect } from 'react-redux';
const mapStateToProps = (state)=>{
    if (state.config.featureFlags.ProfileExp === 'true') {
        return {
            renderProfile: true,
            userLeadgenProfile: state.users.profile
        };
    }
    return {
        userLeadgenProfile: state.users.profile
    };
};
const mapDispatchToProps = (dispatch)=>{
    return {
        getUserProfile: ()=>dispatch(getUserProfile()),
        updateUserProfile: (profile)=>dispatch(updateUserProfile(profile))
    };
};
export const UserProfileModal = connect(mapStateToProps, mapDispatchToProps)(UserProfileModalComponent);
